import React from 'react';
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { CircularProgress } from '@material-ui/core';
import funnel from 'highcharts/modules/funnel.js';

const FunnelChart = props => {
	funnel(Highcharts);

	const { data, isLoading } = props;

	let empresasNuevas;
	let empresasTrialCalificado;
	let empresasAceptanCondiciones;
	let options;

	if (isLoading === false) {
		empresasNuevas = parseFloat(data.empresasNuevas);
		empresasTrialCalificado = parseFloat(data.empresasTrialCalificado);
		empresasAceptanCondiciones = parseFloat(data.empresasAceptanCondiciones);

		options = {
			chart: {
				type: 'funnel',
			},
			title: {
				text: 'Funnel Empresas',
			},
			plotOptions: {
				series: {
					dataLabels: {
						enabled: true,
						format: '<b>{point.name}</b> ({point.y:,.0f})',
						softConnector: true,
					},
					center: ['50%', '50%'],
					neckWidth: '30%',
					neckHeight: '25%',
					width: '80%',
				},
			},
			legend: {
				enabled: false,
			},
			series: [
				{
					name: 'Empresas',
					data: [
						['Registros', empresasNuevas],
						['Trial Calificado', empresasTrialCalificado],
						['Aceptan Condiciones', empresasAceptanCondiciones],
					],
				},
			],

			responsive: {
				rules: [
					{
						condition: {
							maxWidth: 500,
						},
						chartOptions: {
							plotOptions: {
								series: {
									dataLabels: {
										inside: true,
									},
									center: ['50%', '50%'],
									width: '100%',
								},
							},
						},
					},
				],
			},
		};
	}

	return <React.Fragment>{isLoading ? <CircularProgress /> : <HighchartsReact highcharts={Highcharts} options={options} />}</React.Fragment>;
};

export default React.memo(FunnelChart);
